import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import Switch from "@material-ui/core/Switch";

const BlueSwitch = withStyles((theme) => ({
    switchBase: {
        color: "#fff",
        "&$checked": {
            color: "#fff",
        },
        "&$checked + $track": {
            backgroundColor: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
            opacity: "1",
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "1px solid " + (theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue),
        },
    },
    thumb: {
        backgroundColor: "white",
        border: "1px solid " + (theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue),
    },
    checked: {},
    track: {
        backgroundColor: "#6B8799",
        opacity: "1",
    },
}))(Switch);

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        width: "fit-content",
        alignItems: "center",
    },
    label: {
        cursor: "pointer",
        minWidth: "180px",
        marginLeft: "20px",
        flex: "1",
        font: "16px " + theme.typography.fontFamilySecondary,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
    },
}));

export default function BSL_ToggleButton(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <div className={classes.root}>
            <div className={classes.label} onClick={props.onChange}>
                {props.label}
            </div>
            <BlueSwitch
                checked={props.checked}
                // onChange={props.onChange}
                onClick={props.onChange}
                name={props.name ? props.name : props.label}
            />
        </div>
    );
}
